module.exports = __webpack_public_path__ + "img/group.e56ab1fe.png";